/**
 * What this client is, said to the server (docs/architecture/MOBILE-APP-ARCHITECTURE-2026-11-02.md, backend
 * client_compat.py). One web app runs in a browser and inside the Capacitor store app; the store app can be an old
 * build, so it says which build it is, and the experience answer says whether that build is still supported.
 *
 * `REACT_APP_RELEASE` is the build's version (CI sets it; the native build uses the same value as its versionName).
 */
export function clientKind() {
  const cap = typeof window !== 'undefined' ? window.Capacitor : undefined;
  if (!cap?.isNativePlatform?.()) return 'web';
  const platform = cap.getPlatform?.();
  return platform === 'ios' || platform === 'android' ? platform : 'web';
}

export function appVersion() {
  return process.env.REACT_APP_RELEASE || process.env.REACT_APP_VERSION || '';
}

/** The two headers every client sends on the experience call. */
export function clientHeaders() {
  const headers = { 'X-Client': clientKind() };
  const version = appVersion();
  if (version) headers['X-App-Version'] = version;
  return headers;
}

/** True when the server says this installed app is too old to use (never for the web). */
export function updateRequired(exp) {
  return exp?.client?.update_required === true && exp?.client?.kind !== 'web';
}
